<template>
<div>
  <ion-row>
    <ion-col size="12">
      <ion-item color="light">
        <ion-label>Dashboard</ion-label>
      </ion-item>
    </ion-col>
    <ion-col class="ion-no-padding">
      <ion-card>
        <ion-item color="primary">
          <ion-label class="ion-text-center" text-wrap>
            <h1>{{datos.ordenes.length}}</h1>
            <p>Órdenes creadas</p>
          </ion-label>
        </ion-item>
      </ion-card>
    </ion-col>
    <ion-col class="ion-no-padding" v-if="empresa.medirTiemposDeOrdenes">
      <ion-card>
        <ion-item color="secondary">
          <ion-label class="ion-text-center" text-wrap>
            <h1>{{datos.terminados}}</h1>
            <p>Órdenes terminadas</p>
          </ion-label>
        </ion-item>
      </ion-card>
    </ion-col>
    <ion-col class="ion-no-padding">
      <ion-card>
        <ion-item color="tertiary">
          <ion-label class="ion-text-center" text-wrap>
            <h1>{{Object.keys(datos.porEquipo).length}}</h1>
            <p>Equipos revisados</p>
          </ion-label>
        </ion-item>
      </ion-card>
    </ion-col>
    <ion-col class="ion-no-padding" v-if="empresa.calcularCostos">
      <ion-card>
        <ion-item color="warning">
          <ion-label class="ion-text-center" text-wrap>
            <h1>{{datos.totalCostos | currency}}</h1>
            <p>Total de costos</p>
          </ion-label>
        </ion-item>
      </ion-card>
    </ion-col>
    <ion-col class="ion-no-padding" v-if="empresa.medirTiemposDeOrdenes">
      <ion-card>
        <ion-item color="danger">
          <ion-label class="ion-text-center" text-wrap>
            <h1>{{(datos.tiempoCompletado/datos.ordenes.length)/(1000*60*60) | currency('')}}hrs</h1>
            <p>Tiempo promedio por orden</p>
          </ion-label>
        </ion-item>
      </ion-card>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size-sm="6" size-xs="12">
      <ion-item-divider>Órdenes creadas</ion-item-divider>
      <LineChart v-if="datacollection" :chart-data="datacollection" />
    </ion-col>
    <ion-col size-sm="6" size-xs="12">
      <ion-item-divider>Por cliente</ion-item-divider>
      <BarChart v-if="datacollectionPorCliente" :chart-data="datacollectionPorCliente" />
    </ion-col>
    <ion-col size-sm="6" size-xs="12">
      <ion-item-divider>Por usuario</ion-item-divider>
      <BarChart v-if="datacollectionPorUsuario" :chart-data="datacollectionPorUsuario" />
    </ion-col>
  </ion-row>
</div>
</template>
<script>
//import Api from '@/components/Api/Api'
import LineChart from '@/components/Extras/LineChart.vue'
import BarChart from '@/components/Extras/BarChart.vue'
export default {
  name: 'Dashboard',
  data() {
    return {
      generandoHistograma: false,
      datacollection: null,
      datacollectionPorCliente: null,
      datacollectionPorUsuario: null,
      empresa: {}
    }
  },
  components: {
    LineChart,
    BarChart
  },
  props: {
    datos: {
      type: Object,
      default: function() {
        return {}
      }
    },
    catalogos: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  methods: {
    async generarHistograma() {
      if (!this.generandoHistograma) {
        this.generandoHistograma = true
        console.log("generandoHistograma" + new Date().getTime())
        // Mapeo de las fechas
        let fechas = [],
          templateServicios = []
        for (let i = new Date(this.datos.desdeFecha).getTime(); i <= new Date(this.datos.hastaFecha).getTime(); i += (1000 * 60 * 60 * 24)) {
          fechas.push(this.$options.filters.moment(i, 'MMM DD'))
          templateServicios.push(0)
        }
        // General
        this.datacollection = {
          labels: fechas,
          datasets: [{
            label: 'Ordenes creadas',
            backgroundColor: '#f85050',
            data: JSON.parse(JSON.stringify(templateServicios))
          }]
        }
        // Por cliente
        let clientesEnOrdenes = this.datos.ordenes.map(o => o.idCliente)
        let clientesActivos = this.catalogos.clientes.filter(c => clientesEnOrdenes.indexOf(c._id) >= 0)
        this.datacollectionPorCliente = {
          labels: fechas,
          datasets: clientesActivos
            //.splice(0, 10)
            .map(cl => {
              return {
                label: cl.alias || cl.nombre,
                _id: cl._id,
                backgroundColor: this.randomColor(),
                data: JSON.parse(JSON.stringify(templateServicios))
              }
            }),
          options: {
            scales: {
              x: {
                display: false
              },
              yAxes: [{
                ticks: {
                  stepSize: 1,
                  beginAtZero: true,
                }
              }]
            }
          }
        }
        // Por empleado
        let usuariosEnOrdenes = this.datos.ordenes.map(o => o.idAutor)
        let usuariosActivos = this.catalogos.usuarios.filter(u => usuariosEnOrdenes.indexOf(u._id) >= 0)
        this.datacollectionPorUsuario = {
          labels: fechas,
          datasets: usuariosActivos.map(u => {
            return {
              label: u.alias || u.nombre || u.email,
              _id: u._id,
              backgroundColor: this.randomColor(),
              data: JSON.parse(JSON.stringify(templateServicios))
            }
          }),
          scales: {
            yAxes: [{
              ticks: {
                stepSize: 1,
                beginAtZero: true,
              }
            }]
          }
        }
        console.log("Fechas", fechas)
        console.log("Ordenes", this.datos.ordenes)
        //
        for (let orden of this.datos.ordenes) {
          let indiceFecha = fechas.indexOf(this.$options.filters.moment(orden.fechaCreada, 'MMM DD'))
          if (fechas[indiceFecha] == this.$options.filters.moment(orden.fechaCreada, 'MMM DD')) {
            this.datacollection.datasets[0].data[indiceFecha]++
            let indiceCliente = (clientesActivos.map(c => c._id)).indexOf(orden.idCliente)
            this.datacollectionPorCliente.datasets[indiceCliente].data[indiceFecha]++
            let indiceUsuario = (usuariosActivos.map(u => u._id)).indexOf(orden.idAutor)
            this.datacollectionPorUsuario.datasets[indiceUsuario].data[indiceFecha]++
          }
        }
        await Api.wait(250)
        this.generandoHistograma = false
        console.log("Histogramas", this.datacollection, this.datacollectionPorCliente, this.datacollectionPorUsuario)
      }
    },
    randomColor() {
      let color = '#'
      for (let i = 0; i < 3; i++)
        color += Math.floor(Math.random() * 255).toString(16)
      return color
    }
  },
  watch: {
    'datos': function(a) {
      this.generarHistograma()
    }
  },
  async mounted() {
    console.log("ReporteDashboard", this.datos)
    this.empresa = (await Api.get('empresa'))[0] || {}
    this.generarHistograma()
  }
}
</script>
